import { isNil } from 'lodash';
import { DEFAULT_LINE_PROPS } from '../../../../../Shape/config/Shapes';

const getCoords = shape => (isNil(shape.get('coords')) ? DEFAULT_LINE_PROPS.coords : shape.get('coords').toJS());

export default getCoords;
